<template>
  <div>
    <ul class="nav nav-pills nav-fill" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          id="package-tab"
          data-toggle="tab"
          href="#package"
          role="tab"
          aria-controls="package"
          aria-selected="true"
          ><i class="fa fa-dropbox"></i> Packages</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="topup-tab"
          data-toggle="tab"
          href="#topup"
          role="tab"
          aria-controls="topup"
          aria-selected="true"
          ><i class="fa fa-database"></i> Topups</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="networkRangePackage-tab"
          data-toggle="tab"
          href="#networkRangePackage"
          role="tab"
          aria-controls="networkRangePackage"
          aria-selected="true"
          ><i class="fa fa-plus-square"></i> Network Range Packages</a
        >
      </li>
    </ul>
    <div class="tab-content">
      <div
        class="tab-pane active"
        id="package"
        role="tabpanel"
        aria-labelledby="package-tab"
      >
        <CappedConnectivityPackagePrices
          :userEditRight="userEditRight"
          :productNumber="productNumber"
          :packages="cappedPackages"
          :emptyPackage="emptyPackage"
          @get-connectivity-packages="getConnectivityPackages"
        />
      </div>
      <div
        class="tab-pane"
        id="topup"
        role="tabpanel"
        aria-labelledby="topup-tab"
      >
        <ConnectivityPackageTopups
          :userEditRight="userEditRight"
          :productNumber="productNumber"
          :packages="topupPackages"
          :emptyTopup="emptyTopup"
          @getConnectivityTopups="getConnectivityTopups"
        />
      </div>
      <div
        class="tab-pane"
        id="networkRangePackage"
        role="tabpanel"
        aria-labelledby="networkRangePackage-tab"
      >
        <NetworkRangePackagePrices
          :userEditRight="userEditRight"
          :productNumber="productNumber"
          :packages="networkRangePackages"
          @getNetworkRangePackages="getNetworkRangePackages"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CappedConnectivityPackagePrices from "@/components/Admin/ConnectivityPackages/CappedConnectivityPackagePrices";
import ConnectivityPackageTopups from "@/components/Admin/ConnectivityPackages/ConnectivityPackageTopups";
import NetworkRangePackagePrices from "@/components/Admin/NetworkRangePackages/NetworkRangePackagePrices";
export default {
  props: {
    productNumber: {
      type: Number,
      required: true,
    },
    userEditRight: {
      type: Boolean,
      required: true
    },
  },
  components: {
    CappedConnectivityPackagePrices,
    ConnectivityPackageTopups,
    NetworkRangePackagePrices,
  },
  data() {
    return {
      cappedPackages: [],
      topupPackages: [],
      networkRangePackages: [],
      emptyPackage: {},
      emptyTopup: {},
    };
  },
  mounted() {
    this.getConnectivityPackages();
    this.getConnectivityTopups();
    this.getNetworkRangePackages();
  },
  methods: {
    getConnectivityPackages() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/connectivitypackages/product/" +
            this.productNumber
        )
        .then(
          (response) => {
            this.cappedPackages = response.data.connectivitypackages;
            this.emptyPackage = response.data;
          },
          (error) => {
            this.showError("Error fetching Connectivity Packages", error);
            console.error(error);
          }
        );
    },
    getConnectivityTopups() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/connectivitytopups/" +
            this.productNumber
        )
        .then(
          (response) => {
            this.topupPackages = response.data.connectivitytopups;
            this.emptyTopup = response.data;
          },
          (error) => {
            this.showError("Error fetching Connectivity Topups", error);
            console.error(error);
          }
        );
    },
    getNetworkRangePackages() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/networkrangepackages/product/" +
            this.productNumber
        )
        .then(
          (response) => {
            this.networkRangePackages = response.data;
          },
          (error) => {
            console.error(error);
            this.showError("Error fetching Network Range Packages", error);
          }
        );
    },
  },
};
</script>

<style scoped>
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #f05050 !important;
}
.nav-pills .nav-link {
  background-color: #f3f2ee;
}
a {
  color: rgba(0, 0, 0, 0.6);
}
</style>